/* generated by tpl.py, DO NOT edit */
/* jshint -W004 */
/* jshint -W053 */
/* global exports */
/* exported tpl__comment */
function tpl__comment() {
    var __out = '<div><div class="mi-detail__delete" style="display: none;"></div><div class="mi-detail__content" style="display: none;"><div class="mi-detail__notify">确认删除？</div><div class="mi-detail__option mi-detail__second">取消</div><div class="mi-detail__option mi-detail__first">删除</div></div></div>';
    return __out;
}

exports.tpl__comment = tpl__comment;
